import { FacturasAdapters } from "../adapters/facturas.adapters"
import { useIntegraWeb } from "./noticias.services"

/**
 * Servei de factures del WS d'Activitats (adminactivitats).
 *
 * Igual que notícies, activitats, cursos i inscripcions, és un servei EXTERN a la
 * API del backoffice: es crida amb `fetch` des del fetcher compartit `useIntegraWeb`
 * i la resposta es normalitza amb `FacturasAdapters`.
 *
 * URL: {REACT_APP_WEB_SERVICE_ACTIVIDADES}/integraWeb.php?accion=...
 */
const FacturasServices = {

    OBTENER_FACTURAS: function () {

        return useIntegraWeb(FacturasAdapters.OBTENER_FACTURAS)
    },

    GET_TIPOS_FACTURA: function () {

        return useIntegraWeb(FacturasAdapters.GET_TIPOS_FACTURA)
    },
}

export {
    FacturasServices
}